import { defaultConfig } from './config'

export function formatCurrency(value, currency = window.Shopify.currency.active || defaultConfig.currency) {
    const formats = {
        EUR: () => {
            return `${new Intl.NumberFormat('lt-LT', {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} €`
        },
        USD: () => {
            return `$${new Intl.NumberFormat('en-US', {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
        CAD: () => {
            return `CA$${new Intl.NumberFormat('en-CA', {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
    }

    return formats[currency]?.() ?? `${value} ${currency}`
}

export const parseInteger = (value) =>
    value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0

class Storefront {
    constructor(data) {
        this.apiVersion = data.apiVersion;
        this.shopName = data.shopName;
        this.storefrontToken = data.storefrontToken;

        this.headers = {
            'X-Shopify-Storefront-Access-Token': this.storefrontToken,
            'Content-Type': 'application/json',
        };
    }
  
    async request({ query, variables = {} }) {
        const response = await fetch(
        `https://${this.shopName}/api/${this.apiVersion}/graphql.json`,
            {
                headers: this.headers,
                method: 'POST',
                body: JSON.stringify({ query, variables }),
            },
        );
      
        if (response?.status === 200){
            return await response.json();
        }
        return false;
    }
}

let storefrontInstance = null;

const createStorefront = () => {
    if (storefrontInstance) {
        return storefrontInstance;
    }
    const technicalDataEl = document.querySelector('[data-technical]');
    if (!technicalDataEl) {
        console.error('utils/storefront/index.js: Could not locate Storefront credentials');
        return null;
    }
    const data = JSON.parse(technicalDataEl.textContent);
    storefrontInstance = new Storefront(data);
    return storefrontInstance;
}

export const getProductByHandle = async (handle) => {
    const storefront = createStorefront();

    if(!storefront) {
        console.error('Storefront technical element not found.');
        return null;
    }

    const response = await storefront.request({
        query: `
            query product(
                $handle: String!
                $countryCode: CountryCode!,
                $languageCode: LanguageCode!
            ) 
            @inContext (
                country: $countryCode,
                language: $languageCode,
            ) {
                productByHandle(handle: $handle) {
                    standardBadge: metafield(namespace: "custom", key: "badge") {
                        id 
                        reference
                        {
                            ... on Metaobject {
                                handle
                                id
                                type
                                fields{
                                    value
                                    key
                                }
                            }
                        }
                    }
                    awardBadge: metafield(namespace: "custom", key: "award_badge") {
                        id 
                        reference
                        {
                            ... on Metaobject {
                                handle
                                id
                                type
                                fields{
                                    reference{
                                        ... on MediaImage{
                                            image {
                                                url
                                                altText
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    productCardHoverImage: metafield(
                        namespace: "custom", key: "product_card_hover_image"
                    ){
                        reference{
                            ... on MediaImage{
                                image {
                                    url
                                    altText
                                }
                            }
                        }
                    }
                    kitOptionGroup1: metafield(
                        namespace: "custom",
                        key: "kit_option_group_1"
                    ){
                        key
                        references(first: 1) {
                            nodes {
                                ... on Product {
                                    handle
                                    id
                                }
                            }
                        }
                    }
                    scentColors: metafield(namespace: "custom", key: "scent_icons") {
                        id
                        references(first: 10) {
                        edges {
                            node {
                            ... on Metaobject {
                                    handle
                                    id
                                    fields {
                                        value
                                        key
                                    }
                                }
                            }
                        }
                    }
                    
                }
            }
        }
        `,


        variables: { 
            handle, 
            countryCode: window.TMW?.localization?.countryCode || window.Shopify?.country, 
            languageCode: window.TMW?.localization?.languageCode || window.Shopify?.locale?.toUpperCase()
        },
    });
    return response;
};